/* eslint-disable max-len */
import React from 'react';
import { Form, Label, Pane } from '@leverege/ui-elements';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function IntEditor(props) {
  const {
    attr
  } = props;
  const hint = attr?.blueprint?.attribute?.getTagStartingWith('hint:', true);
  return /*#__PURE__*/_jsxs(Pane, {
    layout: "flex:colS",
    children: [/*#__PURE__*/_jsx(Label, {
      variant: "inputTitle",
      children: attr.displayName
    }), /*#__PURE__*/_jsx(Form.NumericInput, {
      hint: hint,
      alwaysFireOnReturn: false,
      changeOnReturn: false,
      variant: "inputGrow",
      name: attr?.blueprint?.updatePath,
      float: false
    }), /*#__PURE__*/_jsx(Form.Error, {
      variant: "inputCaptionSmallError",
      name: attr?.blueprint?.updatePath
    })]
  });
}
const type = 'int';
export default {
  editor: IntEditor,
  type
};